export default hashid => (
  window.open(`${process.env.API_LOCATION}/invoices/${hashid}/pdf/download/?token=${localStorage.getItem('id_token')}`)
);



// WEBPACK FOOTER //
// ./src/app/services/invoice/download.js